import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

import AnimationRevealPage from "../helpers/AnimationRevealPage";
import MainFeature from "components/features/TwoColWithButton";
import Footer from "components/footers/FiveColumnWithBackground";
import Header from "../components/headers/light";

import ourProjectSrc from "images/our-project.png";

export default function AboutProject() {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;

  return (
    <AnimationRevealPage disabled>
      <Header />
      <MainFeature
        subheading={<Subheading>Proyecto</Subheading>}
        heading={
          <>
            Te contamos más sobre este{" "}
            <span tw="text-primary-500">Increíble Proyecto.</span>
          </>
        }
        imageSrc={ourProjectSrc}
        imageBorder={false}
        imageDecoratorBlob={true}
        withoutButton={true}
        showDescriptions={true}
        descriptions={[
          "La aplicación móvil ADA consiste en un proyecto para generación automática de dictados musicales guiados por la configuración del profesor. La aplicación está especialmente diseñada para atender las necesidades de entrenamiento auditivo de estudiantes de las licenciaturas en interpretación musical. Se atiende a cubrir la necesidad de contar con una herramienta desarrollada en software libre que permita al profesor guiar el entrenamiento de sus estudiantes minimizando el esfuerzo dedicado a la producción de los dictados y maximizando las posibilidades de entrenamiento para los estudiantes. Se presenta la aplicación ADA desarrollada en JavaScript, de código abierto para la generación de dictados melódicos y rítmicos.",
        ]}
      />
      <Footer />
    </AnimationRevealPage>
  );
}
